import urlConfig from "../config/urlConfig.js";

var authority = urlConfig.authority;
var erp = urlConfig.erp;
var pos = urlConfig.pos;

var superApi = {
  // 公司管理员列表
  superUserList: "/superManager/selectCompanyManagerList",
  // 删除公司管理员
  superUserDel: "/superManager/del/",
  // 添加公司管理员
  superUserAdd: "/superManager/addSuperUser",
  // 修改公司管理员
  superUserUpdate: "/superManager/modifySuperUser",
  // 查询公司列表
  companyList: "/sysCompany/all",
  // 查询企业功能
  functionList: "/sysFunction/all",
  //查询企业功能，带按钮
  functionListAndBtn: "/sysFunction/getFnAndBtn",
  // 查询公司管理列表
  sysCompanyList: "sysCompany/showList",
  // 删除公司
  sysCompanyDel: "/sysCompany/del/",
  // 添加公司
  addCompany: "/sysCompany/addCompany",
  // 修改公司
  modifyCompany: "/sysCompany/modifyCompany",
  //查询门店管理员接口
  sysUserList: "/superManager/selectStoreManagerList",
  //添加门店管理员
  sysAdd: "/adminmanager/addAdmin",
  //修改门店管理员
  sysUpdate: "/adminmanager/modifyAdmin",
  //获取机构
  getStoresByParentId: "/erpStoreInfo/selectValidStoresByParentId/",
  //机构管理列表
  erpStoreInfoshowList: "/erpStoreInfo/showList",
  //查询省市区
  findErpRegionById: "erpRegion/findErpRegionById/",
  //修改机构
  modifyErpStoreInfo: "/erpStoreInfo/modifyErpStoreInfo",
  //添加机构
  addErpStoreInfo: "/erpStoreInfo/addErpStoreInfo",
  //机构管理审批
  approveErpStoreInfo: "/erpStoreInfo/approveErpStoreInfo",
  //[机构管理]—根据父id查询所有子机构
  selectValidStoresByParentId: "/erpStoreInfo/getStoresByParentId/",
  //根据ID 查询
  getStoreById: "/erpStoreInfo/getStoreById/",
  //重置密码
  resetPassword: "/adminmanager/su/resetPassword/",
  // 用户解锁，锁定
  accountLock: "/adminmanager/accountLock",
  //查询所有公司所属门店
  selectListByCompanyId: "/erpStoreInfo/selectListByCompanyId/",
  //根据角色id查询角色
  searchRole: "/role/su/queryRole",
  //[资源权限管理]—资源权限查询
  selectRelationByModel: "/erpResourcesAuth/selectRelationByModel",
  //[资源权限管理]—用户拥有的资源权限查询
  selectAuthRoleByModel: "/erpResourceAuthRole/su/selectAuthRoleByModel"
};
export default superApi;



// WEBPACK FOOTER //
// ./src/api/superApi.js